export const environment = {
    apiUrl: "https://api.appdietology.eu",
    recaptchaSiteKey: "6Lcfo0YqAAAAAPEABY6AW6WY3f-qHOe6yuH01B8E",
    production: true
};
